module.exports = __webpack_public_path__ + "static/media/uni_banka.490c7c47.png";